
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fav",
      function () {
        return require("private-next-pages/fav.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fav"])
      });
    }
  